import { mk_widget, Action, IOWidget } from 'widgets-for-react'
import * as React from 'react'
import { MouseClickEvent } from '../../../helpers'
import ReactDOM from 'react-dom'
import { createPopper } from '@popperjs/core'


export interface SidenoteProps<s> {
  input: s
  widget_s: IOWidget<s, Action<s>>
  on_done_s: (output_s: Action<s>) => void
}
export interface SidenoteState<s> {
  sidenote?: string
  targetEl?: HTMLElement
}
export class Sidenote<s> extends React.Component<
  SidenoteProps<s>,
  SidenoteState<s>
> {
  
  private sidenote: React.RefObject<HTMLElement> = React.createRef<HTMLElement>();
  constructor(props: SidenoteProps<s>, context: any) {
    super(props, context)
    this.state = {}
    this.handleClick = this.handleClick.bind(this)
    this.handleClickWhenOpen = this.handleClickWhenOpen.bind(this)
    this.closeSidenote = this.closeSidenote.bind(this)
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClick)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClick)
    document.removeEventListener('click', this.handleClickWhenOpen)
  }

  componentDidUpdate() {
    this.state.targetEl && 
    this.sidenote.current && 
      createPopper(this.state.targetEl, this.sidenote.current)
  }

  handleClick(e: MouseClickEvent<HTMLElement>) {
    if (e.target.tagName?.toLowerCase() == 'abbr' && e.target.dataset?.sidenote) {
      this.setState({ targetEl: e.target, sidenote: e.target.dataset.sidenote })
      document.addEventListener('click', this.handleClickWhenOpen)
    }
  }

  handleClickWhenOpen(e: MouseClickEvent<HTMLElement>) {
    if (this.sidenote.current) {
      let node: Node & ParentNode = e.target as Node & ParentNode
      let isDescendant: boolean = node == this.sidenote.current
      
      if (isDescendant) {
        while (node = node.parentNode) {
          if (node == this.sidenote.current) {
            isDescendant = true
            break;
          }
        } 
      }
      if (!isDescendant) {
        this.closeSidenote()
      }
    }

  }

  closeSidenote() {    
    this.setState({ targetEl: null, sidenote: null})
    document.removeEventListener('click', this.handleClickWhenOpen)
  }

  render() {
    return this.state.sidenote ? ReactDOM.createPortal(
      <>
        <aside className={`sidenote`} ref={this.sidenote}>
          <svg width="23px" height="30px" viewBox="0 0 23 30" version="1.1">
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="News-detail" transform="translate(1.000000, 1.000000)" stroke="#74BDE9" strokeWidth="2">
                  <polygon id="Stroke-1" points="17.1129 28 3.1129 28 0.1129 0 20.1129 0"></polygon>
                  <path d="M0.8228,7.1103 C5.7278,11.7313 14.8188,3.0653 19.1128,7.1103" id="Stroke-3"></path>
                </g>
            </g>
          </svg>
          <button className={`sidenote__close`} onClick={this.closeSidenote}>&times;</button>
          <div 
            className={`sidenote__body`} 
            dangerouslySetInnerHTML={{ __html: this.state.sidenote }}
          />
        </aside>
      </>,
      document.body
    ) : null
  }
}
export let sidenote = function<s>(): (widget_s: IOWidget<s, Action<s>>) => IOWidget<s, Action<s>> {
  return widget_s => (input: s) =>
    mk_widget({
      run: (on_done_s: (output: Action<s>) => void) =>
        React.createElement<SidenoteProps<s>>(Sidenote, {
          on_done_s,
          widget_s,
          input
        })
      })
  }